import { GlobalResponseObject } from "../../../global-response-object";
import { StyleOperationsTimeConsModel } from "./style-operations-time-cons.model";

export class StyleOperationsTimeConsResponse extends GlobalResponseObject {
    data?: StyleOperationsTimeConsModel[];

    constructor(status: boolean, intlCode: number, internalMessage: string, data?: StyleOperationsTimeConsModel[]){
        super(status,intlCode,internalMessage)
        this.data = data;
    }
}
